import { Deliveries } from "modules/financial";

const DeliveriesPage = () => {
  return <Deliveries />;
};

export default DeliveriesPage;
